// src/features/design/GlobalDesignBar/DragSelectRoomsControl.tsx
import React, { useCallback } from "react";
import { ActionIcon, Badge, Group, Tooltip } from "@mantine/core";
import { TbDragDrop, TbX } from "react-icons/tb";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { setDragSelectSpacesInRedux, removeSelectedRoomFromRedux } from "../designSlice";

export const DragSelectRoomsControl: React.FC = () => {
  const dispatch = useAppDispatch();

  const dragSelectSpaces = useAppSelector((s) => s.design.dragSelectSpaces);
  const measurementToolActive = useAppSelector((s) => s.design.measurementToolActive);
  const selectedRooms = useAppSelector((s) => s.design.selectedRooms);

  const selectedCount = selectedRooms?.length ?? 0;
  const isDisabled = dragSelectSpaces || measurementToolActive;

  const handleStartDragSelect = useCallback(() => {
    if (isDisabled) return;
    dispatch(setDragSelectSpacesInRedux(true));
  }, [dispatch, isDisabled]);

  const handleResetSelection = useCallback(() => {
    if (!selectedRooms || selectedRooms.length === 0) return;

    // Antagande: removeSelectedRoomFromRedux tar hela rums-objektet som payload.
    // Justera till rätt payload om den i stället ska ha t.ex. roomId.
    selectedRooms.forEach((room: any) => {
      dispatch(removeSelectedRoomFromRedux(room));
    });
  }, [dispatch, selectedRooms]);

  return (
    <Group gap="xs">
      <Tooltip
        label="Dra og velg for å velge flere rom samtidig"
        position="bottom"
        withArrow
      >
        <ActionIcon
          variant={dragSelectSpaces ? "filled" : "subtle"}
          size={34}
          radius="xl"
          disabled={isDisabled}
          onClick={handleStartDragSelect}
        >
          <TbDragDrop size={16} />
        </ActionIcon>
      </Tooltip>

      {selectedCount > 0 && (
        <Group gap={4}>
          <Badge radius="xl" variant="light" size="sm">
            {selectedCount} rom valgt
          </Badge>

          <Tooltip label="Nullstill valgte rom" position="bottom" withArrow>
            <ActionIcon
              variant="subtle"
              size={26}
              radius="xl"
              onClick={handleResetSelection}
            >
              <TbX size={14} />
            </ActionIcon>
          </Tooltip>
        </Group>
      )}
    </Group>
  );
};
